<template>
  <div v-if="titulos.length > 0">
    <v-container
      fluid
      v-bind:class="{ 'pa-0': titulos.length == 0, 'pa-2': titulos.length > 0 }"
      class="pt-5 bk-footer-as"
    >
      <v-layout justify-center>
        <v-flex xs10>
          <v-layout
            :row="!$vuetify.breakpoint.xs"
            :column="$vuetify.breakpoint.xs"
          >
            <v-flex
              xs3
              v-for="(t, index) in titulos"
              :key="`titulo-${t.id}-${index}`"
              class="pa-2"
              data-cy="panelTitulos"
            >
              <p class="caption font-weight-regular mb-0 white--text">
                {{ t.nombre.toUpperCase() }}
              </p>
              <v-divider class="mt-1"></v-divider>
              <ul>
                <li
                  v-for="(l, lind) in t.links"
                  :key="lind"
                  class="ul-not-dot-as text-xs-left caption font-weight-light mb-1 white--text"
                >
                  <span
                    class="cur-pointer"
                    @click="
                      l.url != null ? _$goToUrl(l.url) : (promociones = true)
                    "
                  >
                    {{ l.nombre }}
                  </span>
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout row justify-center>
      <v-dialog
        v-model="promociones"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="red darken-4">
            <img
              src="https://www.allseasons.tur.ar/ws/utiles/img/logo.png"
              alt="All Seasons"
              id="logo-as"
            />
            <v-spacer></v-spacer>
            <v-btn icon dark @click="promociones = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <allseasons-promociones v-if="promociones"></allseasons-promociones>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "linksUtiles",
  props: { cliente_id: Number },
  components: {},
  mounted() {
    this.getLinks(this.cliente_id);
  },
  beforeCreate() {},
  methods: {
    async getLinks(clienteId) {
      var header = this.$passporthandler.prepareHeader();
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" });
      }
      this.$axiosHandlerAs.prepare(
        process.env.VUE_APP_ASBACK + `/api/cliente-titulos/${clienteId}`,
        header
      );
      this.$axiosHandlerAs.overlay(false);
      await this.$axiosHandlerAs.exe();
      this.titulos = this.$axiosHandlerAs.getData().titulos;
      this.titulos[0].links.push({
        id: 10,
        nombre: "Tarjetas de crédito - Promociones.",
        url: null
      });
    }
  },
  beforeRouteEnter(to, from, next) {},
  data() {
    return {
      titulos: [],
      promociones: false
    };
  },
  watch: {
    cliente_id: function(newVal, oldVal) {
      this.getLinks(newVal);
    }
  }
};
</script>
<style scoped="">
/*background: url('https://www.allseasons.tur.ar/ws/utiles/img/footer.png')*/
.bk-footer-as {
  background: url("https://www.allseasons.tur.ar/ws/utiles/img/footer.png");
  background-color: rgba(0, 0, 0, 0);
  background-position-x: 0%;
  background-position-y: 0%;
  background-repeat: repeat;
  background-position: bottom;
  background-repeat: repeat-x;
  background-color: #88203f;
}
</style>
